/**
 * Manages the modal display for pie chart details
 * Handles populating modal content with product information
 */
export class ModalManager {
  constructor(colorSchemes, pieChartRenderer) {
    this.colorSchemes = colorSchemes
    this.pieChartRenderer = pieChartRenderer
  }

  openModal(data) {
    const modal = document.getElementById('modal-pie')
    if (!modal) return

    const modalTitle = modal.querySelector('#modal-title-pie')
    const modalCanvas = modal.querySelector('.modal-canvas')
    const modalInfo = modal.querySelector('.modal-info')
    const modalFooter = modal.querySelector('#modal-footer-pie')

    this.setTitle(modalTitle, data)
    this.setCanvas(modalCanvas, data)
    this.setInfo(modalInfo, data)
    this.setFooter(modalFooter, data)
  }

  setTitle(modalTitle, data) {
    if (modalTitle) {
      modalTitle.textContent = data.chart_header
      modalTitle.style.color = this.colorSchemes[data.color_scheme].dark
    }
  }

  setCanvas(modalCanvas, data) {
    if (modalCanvas) {
      const canvas = document.getElementById(data.product_name)
      if (canvas) {
        modalCanvas.innerHTML = ''
        modalCanvas.appendChild(this.pieChartRenderer.cloneCanvas(canvas))
      }
    }
  }

  setInfo(modalInfo, data) {
    if (!modalInfo) return

    modalInfo.querySelector('.material').innerHTML = `Made with ${data.name}`
    modalInfo.querySelector('.colors').innerHTML = `Available in ${data.pie_color} ${data.pie_color === 1 ? 'color' : 'colors'}`
    
    this.setExpansionInfo(modalInfo, data)
    this.setTemperatureInfo(modalInfo, data)
    this.setFlexibilityInfo(modalInfo, data)
    this.setAbrasionInfo(modalInfo, data)
    this.setCostInfo(modalInfo, data)
    this.setCuttingToolInfo(modalInfo, data)
    this.setFunFact(modalInfo, data)
  }

  setExpansionInfo(modalInfo, data) {
    let expansionText = ''
    if (data.pie_expansion === 0) {
      expansionText = 'Does not expand'
    } else if (data.pie_expansion < 50) {
      expansionText = 'Minimal expansion (<50%)'
    } else {
      expansionText = `Expands up to ${data.pie_expansion}%`
    }
    modalInfo.querySelector('.expansion').innerHTML = expansionText
  }

  setTemperatureInfo(modalInfo, data) {
    let tempText = ''
    if (data.temp_continuous !== '' && data.product_name !== 'vectran' && data.product_name !== 'carbonfiber') {
      tempText = `Maximum Continuous: ${data.temp_continuous}&deg;F <br>`
    }
    if (data.pie_temp > 4999) {
      tempText += 'Non-Flammable'
    } else if (data.pie_temp < 200) {
      tempText += 'Melts at a low temperature'
    } else {
      tempText += `Melts at ${data.pie_temp}&deg;F`
    }
    modalInfo.querySelector('.temperature').innerHTML = tempText
  }

  setFlexibilityInfo(modalInfo, data) {
    const flexTexts = ['Very Low Flexibility', 'Low Flexibility', 'Average Flexibility', 'High Flexibility']
    modalInfo.querySelector('.flexibility').innerHTML = flexTexts[data.pie_flexibility] || 'Average Flexibility'
  }

  setAbrasionInfo(modalInfo, data) {
    if (data.abrasion_cycle_count !== '' && data.abrasion_cycle_count != null) {
      modalInfo.querySelector('.cyclecount').innerHTML = `Abrasion Resistance: ${data.abrasion_cycle_count} Cycles`
    } else {
      const abraTexts = ['Low', 'Low', 'Medium', 'High']
      modalInfo.querySelector('.cyclecount').innerHTML = `Abrasion Resistance: ${abraTexts[data.pie_abrasion] || 'Low'}`
    }
  }

  setCostInfo(modalInfo, data) {
    let costText = 'Price: Low'
    if (data.cost_distributor >= 5) {
      costText = 'Price: High'
    } else if (data.cost_distributor > 1.5) {
      costText = 'Price: Medium'
    }
    modalInfo.querySelector('.sliceCost').innerHTML = costText
  }

  setCuttingToolInfo(modalInfo, data) {
    let toolText = 'Cut with '
    if (data.scissors === 3) {
      toolText += 'either a hot knife or scissors'
    } else {
      toolText += data.scissors === 1 ? 'scissors or shears' : 'a hot knife'
    }
    modalInfo.querySelector('.cuttingtool').innerHTML = toolText
  }

  setFunFact(modalInfo, data) {
    const factEl = modalInfo.querySelector('.funfact')
    if (data.fact && data.fact.length > 0) {
      factEl.style.display = 'block'
      factEl.innerHTML = data.fact
    } else {
      factEl.style.display = 'none'
    }
  }

  setFooter(modalFooter, data) {
    if (modalFooter) {
      modalFooter.innerHTML = `<a href='${data.url}' target='_blank' rel='noopener'><b>More About ${data.chart_header} >></b></a>`
    }
  }
}
